document.addEventListener("DOMContentLoaded", (event) => {		
if ($(window).width() < 768) {
  // payment icons on product pages		
  const prodBody = document.querySelector('.template-product');		
  if (prodBody) {		
  var attempts = 0;
  var paymentIconsFn = setInterval( ()=>{
    attempts++;
    var placementEl = document.querySelector('afterpay-placement');
    if (!placementEl || !placementEl.shadowRoot) {
      if (attempts >= 50) clearInterval(paymentIconsFn);
      return;
    }
    var root = placementEl.shadowRoot;
    const payTrigger = root.querySelector('.afterpay-paragraph');	
    if (!payTrigger) {
      if (attempts >= 50) clearInterval(paymentIconsFn);
      return;
    }
    payTrigger.style.cssText = `
  display: flex; 
  margin-bottom: 14px;
  flex-wrap: wrap;	
  font-size: 10px;
  margin-bottom:0px;
`;
    const logoLink = root.querySelector('.afterpay-paragraph .afterpay-logo-link');
    if (logoLink) {
      logoLink.style.cssText = `
  display: flex; 
  align-items: center;
  margin-left:4px;
  margin-bottom:0px;
`;
    }
    payTrigger.classList.add('content-loaded');		
    clearInterval(paymentIconsFn);		
    let payIcons = `<svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="70" height="21" class="compact-badge-logo" viewBox="0 0 100 21"><path class="afterpay-logo-badge-background" fill="#b2fce4" d="M89.85 20.92h-78.9a10.42 10.42 0 110-20.82h78.89a10.42 10.42 0 010 20.83v-.01z"></path><g class="afterpay-logo-badge-lockup"><path d="M85.05 6.37L82.88 5.1l-2.2-1.27a2.2 2.2 0 00-3.3 1.9v.29c0 .16.08.3.22.38l1.03.58c.28.16.63-.04.63-.37v-.67c0-.34.36-.54.65-.38l2.02 1.16 2 1.15c.3.16.3.58 0 .75l-2 1.15-2.02 1.16a.43.43 0 01-.65-.38v-.33a2.2 2.2 0 00-3.28-1.9l-2.2 1.26-2.19 1.25a2.2 2.2 0 000 3.8l2.18 1.25 2.2 1.27a2.2 2.2 0 003.3-1.9v-.3c0-.15-.09-.3-.23-.37L78.02 14a.43.43 0 00-.64.37v.67c0 .34-.36.54-.65.38l-2-1.16-2-1.15a.43.43 0 010-.75l2-1.15 2-1.16c.3-.16.65.05.65.38v.33a2.2 2.2 0 003.3 1.9l2.2-1.26 2.17-1.25a2.2 2.2 0 000-3.8z"></path><path d="M70.77 6.78l-5.1 10.53h-2.12l1.91-3.93-3-6.6h2.17l1.93 4.42 2.1-4.42h2.11z"></path><path d="M19.8 10.5c0-1.24-.92-2.12-2.04-2.12s-2.03.9-2.03 2.14c0 1.23.91 2.14 2.03 2.14s2.03-.88 2.03-2.14m.02 3.74v-.97a3 3 0 01-2.36 1.09c-2.05 0-3.6-1.65-3.6-3.86 0-2.2 1.61-3.87 3.65-3.87.95 0 1.76.42 2.31 1.08v-.95h1.84v7.48h-1.84z"></path><path d="M30.6 12.6c-.65 0-.84-.24-.84-.87V8.4h1.2V6.78h-1.2V4.96h-1.88v1.82h-2.43v-.74c0-.63.24-.87.9-.87h.42V3.72h-.9c-1.56 0-2.3.5-2.3 2.07v1h-1.04V8.4h1.04v5.85h1.88V8.4h2.43v3.66c0 1.53.6 2.19 2.11 2.19h.97V12.6h-.37z"></path><path d="M37.35 9.85c-.13-.97-.93-1.56-1.86-1.56-.92 0-1.7.57-1.88 1.56h3.74zM33.6 11c.13 1.1.93 1.74 1.93 1.74.8 0 1.4-.37 1.76-.97h1.94c-.45 1.58-1.87 2.6-3.74 2.6a3.68 3.68 0 01-3.85-3.85 3.78 3.78 0 013.9-3.9 3.74 3.74 0 013.8 4.38H33.6z"></path><path d="M51.35 10.5c0-1.2-.9-2.12-2.03-2.12-1.12 0-2.03.9-2.03 2.14 0 1.23.9 2.14 2.03 2.14 1.12 0 2.03-.93 2.03-2.14m-5.92 6.79V6.78h1.84v.97a2.97 2.97 0 012.36-1.1c2.02 0 3.6 1.65 3.6 3.85s-1.6 3.87-3.65 3.87a2.9 2.9 0 01-2.26-1v3.93h-1.9.01z"></path><path d="M59.86 10.5c0-1.24-.9-2.12-2.03-2.12-1.12 0-2.04.9-2.04 2.14 0 1.23.92 2.14 2.04 2.14s2.03-.88 2.03-2.14m.02 3.74v-.97a3 3 0 01-2.36 1.09c-2.05 0-3.6-1.65-3.6-3.86 0-2.2 1.61-3.87 3.64-3.87.96 0 1.76.42 2.32 1.08v-.95h1.84v7.48h-1.84z"></path><path d="M42.11 7.5s.47-.86 1.62-.86c.5 0 .8.17.8.17v1.9s-.69-.42-1.32-.33c-.64.09-1.04.67-1.04 1.45v4.42h-1.9V6.78h1.84v.73z"></path></g></svg>`;			
    const mainTextEl = payTrigger.querySelector('.afterpay-main-text');
    if (mainTextEl) {
      let afterpaytext = mainTextEl.innerHTML;
      let afterresult = afterpaytext.replace("or 4 interest-free payments of", "or 4 payments of");
      mainTextEl.innerHTML = `${afterresult}`;
    }
    const logoLinkEl = payTrigger.querySelector('.afterpay-logo-link');
    if (logoLinkEl) {
      logoLinkEl.innerHTML = `${payIcons}`;    
    }
  }, 100);		
  }

  $('#pdp-afterpay-zippay-section').clone().appendTo('#pdp-afterpay-zippay-section-mobile');
}
});

$(document).ready(function(){
  if (navigator.maxTouchPoints > 0) {
    document.querySelector('body').classList.add('touch-device');
  }
  // announcement bar
  $('.close-btn').click(function(){
    $(this).parents('.cc-announcement').remove();
  })
  
  	// Contactus page
    var d = new Date();
    var days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];
    var n = days[d.getDay()];
    $("td").each(function () {
      var data = $(this).html();
      if(n == data) {
        $(this).addClass("active");
      }
    });
    $('.store-time-index .store-time').each(function() {
      var currDate = $(this).find('.day').html();
      if(n == currDate) {
        $(this).addClass("active");
      }
    })

	// var d = new Date();
  //   var weekday = new Array(7);

  //   weekday[0] = "Sunday";
  //   weekday[1] = "Monday";
  //   weekday[2] = "Tuesday";
  //   weekday[3] = "Wednesday";
  //   weekday[4] = "Thursday";
  //   weekday[5] = "Friday";
  //   weekday[6] = "Saturday";

  //   var store_brisbane = {Monday:"9:00am - 5:00pm", Tuesday:"9:00am - 5:00pm", Wednesday:"9:00am - 5:00pm", Thursday:"9:00am - 7:00pm", Friday:"9:00am - 5:00pm", Saturday:"9:00am - 3:00pm", Sunday:"CLOSED"};
  //   var n = weekday[d.getDay()];
  //   if(n in store_brisbane){
  //     var brisbane_time = store_brisbane[n];

  //     $('.brisbane_time span').html(brisbane_time);

  //   } 
  
  // payment icons on product pages
  // const prodBody = document.querySelector('.template-product');
  // if (prodBody) {
  //   var paymentIconsFn = setInterval( ()=>{
  //     const payTrigger = document.querySelector('.afterpay-paragraph');
  //     document.querySelector('.afterpay-paragraph').style.display = "block";
  //     if (payTrigger) {payTrigger.classList.add('content-loaded')}
  //     if(payTrigger.classList.contains('content-loaded')){
  //       clearInterval(paymentIconsFn);
  //       //let payIcons = `<svg class="icon icon-zippay-svg" xmlns="http://www.w3.org/2000/svg" width="57" height="20" viewBox="0 0 57 20"><g fill="none" fill-rule="nonzero"><g fill="#272560"><path d="M27.843 16.338a1.28 1.28 0 0 1-.96-.38 1.306 1.306 0 0 1-.362-.943c-.004-.35.086-.696.26-1.003.153-.275.34-.531.557-.763l5.377-5.873h-4.687c-.454 0-.78-.15-.958-.45-.173-.3-.26-.64-.25-.983a1.498 1.498 0 0 1 .282-.93.991.991 0 0 1 .838-.39h8.282c.35-.015.691.109.945.343.234.226.354.55.354.958.01.318-.06.634-.2.921-.137.25-.307.482-.507.688l-5.6 6.05h5.306c.32-.007.623.133.818.377.208.273.313.607.297.945.015.353-.072.703-.252 1.01-.182.28-.504.424-.956.424l-8.584-.001zM40.852 16.492c-1.474 0-1.78-.73-1.78-1.344V6.202c0-.468.145-.846.434-1.125.29-.278.75-.42 1.372-.42.523 0 .937.115 1.232.343.295.228.459.596.459 1.069V15.1c0 .491-.16.853-.477 1.075-.316.223-.722.316-1.24.316zm0-12.795c-.574 0-1.045-.163-1.401-.483-.356-.32-.542-.762-.542-1.305a1.69 1.69 0 0 1 .54-1.282c.352-.335.825-.505 1.403-.505.477 0 .94.152 1.32.43.413.294.624.752.624 1.36 0 .544-.183.984-.542 1.307-.36.324-.83.481-1.402.481v-.003zM46.411 19.92c-1.378 0-1.67-.742-1.67-1.366V5.899c-.011-.396.146-.78.437-1.06.288-.279.75-.42 1.371-.42.387-.005.768.081 1.113.249.367.181.557.537.557 1.048a4.145 4.145 0 0 1 1.019-.854 4.342 4.342 0 0 1 2.3-.619 5.15 5.15 0 0 1 2.253.471 4.567 4.567 0 0 1 1.636 1.308c.45.591.779 1.26.968 1.972.217.803.323 1.63.316 2.46a8.26 8.26 0 0 1-.363 2.5 5.81 5.81 0 0 1-1.062 1.983 4.876 4.876 0 0 1-1.72 1.306 5.514 5.514 0 0 1-2.32.47 4.91 4.91 0 0 1-1.581-.215 4.427 4.427 0 0 1-1.036-.496 2.842 2.842 0 0 1-.48-.394v2.881c0 .501-.14.871-.42 1.1-.28.227-.709.332-1.318.332zm4.237-12.81a2.275 2.275 0 0 0-1.09.248 2.349 2.349 0 0 0-.79.702c-.23.327-.398.692-.496 1.076a5.291 5.291 0 0 0-.168 1.364c0 1.047.223 1.887.668 2.497.445.61 1.05.894 1.88.894.83 0 1.435-.305 1.855-.934.42-.629.643-1.467.643-2.457a5.293 5.293 0 0 0-.174-1.36 3.43 3.43 0 0 0-.485-1.075 2.244 2.244 0 0 0-.779-.7 2.223 2.223 0 0 0-1.064-.255z"></path></g><g><path fill="#F15B41" d="M20.313 7.45l-4.589 3.987H4.36a4.43 4.43 0 0 0-2.878 1.049l5.731-4.982.088-.075 7.18-6.246a4.475 4.475 0 0 1 4.265-.874c1.481.466 2.593 1.66 2.916 3.13.323 1.473-.192 2.999-1.35 4.005v.005z"></path><ellipse cx="4.36" cy="4.319" fill="#F99D1D" rx="4.36" ry="4.212"></ellipse><path fill="#272560" d="M4.36 11.437a4.43 4.43 0 0 0-2.878 1.049l-.037.032c-1.79 1.556-1.936 4.218-.326 5.948 1.61 1.729 4.366 1.87 6.156.315l8.45-7.343-11.365-.001z"></path><path fill="#00B6BD" d="M15.718 11.44l-8.45 7.343a4.43 4.43 0 0 1-2.916 1.075H17.39c2.515-.039 4.29-1.866 4.29-4.211s-1.91-4.175-4.29-4.212l-1.672.005z"></path></g></g></svg><svg width="74" height="15" viewBox="0 0 74 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M72.8744 2.87339L70.6458 1.59682L68.385 0.300907C66.8906 -0.556587 65.0227 0.520115 65.0227 2.248V2.53813C65.0227 2.69931 65.1065 2.8476 65.2482 2.92497L66.2981 3.52457C66.5879 3.6922 66.9486 3.47944 66.9486 3.14418V2.45431C66.9486 2.1126 67.3158 1.89984 67.6121 2.06747L69.6732 3.25378L71.7279 4.43364C72.0242 4.60127 72.0242 5.03324 71.7279 5.20087L69.6732 6.38073L67.6121 7.56704C67.3158 7.73467 66.9486 7.52191 66.9486 7.1802V6.83849C66.9486 5.11061 65.0807 4.02746 63.5864 4.8914L61.3255 6.18731L59.0969 7.46388C57.5961 8.32782 57.5961 10.5006 59.0969 11.3645L61.3255 12.6411L63.5864 13.937C65.0807 14.7945 66.9486 13.7178 66.9486 11.9899V11.6998C66.9486 11.5386 66.8649 11.3903 66.7232 11.3129L65.6733 10.7133C65.3834 10.5457 65.0227 10.7585 65.0227 11.0937V11.7836C65.0227 12.1253 64.6556 12.3381 64.3593 12.1704L62.2981 10.9841L60.2434 9.80426C59.9471 9.63663 59.9471 9.20466 60.2434 9.03703L62.2981 7.85717L64.3593 6.67086C64.6556 6.50323 65.0227 6.71599 65.0227 7.0577V7.39941C65.0227 9.12729 66.8906 10.2104 68.385 9.3465L70.6458 8.05059L72.8744 6.77402C74.3752 5.90363 74.3752 3.73733 72.8744 2.87339Z" fill="black"/><path d="M58.2531 3.29906L53.0358 14.0854H50.8716L52.8233 10.0559L49.7509 3.29906H51.973L53.944 7.82508L56.0953 3.29906H58.2531Z" fill="black"/><path d="M6.08684 7.12873C6.08684 5.83926 5.15288 4.93664 4.00636 4.93664C2.85985 4.93664 1.92589 5.8586 1.92589 7.12873C1.92589 8.38596 2.85985 9.32082 4.00636 9.32082C5.15288 9.32082 6.08684 8.41819 6.08684 7.12873ZM6.10616 10.9584V9.96555C5.53934 10.6554 4.69556 11.0809 3.69075 11.0809C1.59095 11.0809 0 9.39819 0 7.12873C0 4.87861 1.65536 3.16362 3.73584 3.16362C4.71488 3.16362 5.53934 3.59559 6.10616 4.26611V3.29901H7.98696V10.9584H6.10616V10.9584Z" fill="black"/><path d="M17.1339 9.25639C16.4769 9.25639 16.2901 9.01139 16.2901 8.36666V4.96892H17.5011V3.29906H16.2901V1.42934H14.3643V3.29906H11.878V2.53828C11.878 1.89355 12.1228 1.64855 12.7991 1.64855H13.2242V0.165665H12.2967C10.7057 0.165665 9.9521 0.687897 9.9521 2.28038V3.30551H8.88287V4.96892H9.9521V10.9585H11.878V4.96892H14.3643V8.72126C14.3643 10.2815 14.9633 10.9585 16.522 10.9585H17.514V9.25639H17.1339Z" fill="black"/><path d="M24.0509 6.43876C23.9157 5.44587 23.1041 4.84627 22.1508 4.84627C21.2039 4.84627 20.4181 5.42653 20.2249 6.43876H24.0509ZM20.2056 7.63152C20.3408 8.76625 21.1524 9.41098 22.183 9.41098C22.9946 9.41098 23.6194 9.03059 23.9865 8.41809H25.9639C25.5066 10.0428 24.0509 11.0808 22.1379 11.0808C19.8256 11.0808 18.2024 9.45611 18.2024 7.14152C18.2024 4.82693 19.9157 3.15707 22.183 3.15707C24.4631 3.15707 26.1185 4.83983 26.1185 7.14152C26.1185 7.30915 26.1056 7.47678 26.0734 7.63152H20.2056V7.63152Z" fill="black"/><path d="M38.3824 7.12863C38.3824 5.89074 37.4485 4.93654 36.3019 4.93654C35.1554 4.93654 34.2215 5.8585 34.2215 7.12863C34.2215 8.38585 35.1554 9.32072 36.3019 9.32072C37.4485 9.32072 38.3824 8.37296 38.3824 7.12863ZM32.3214 14.0853V3.29892H34.2021V4.2918C34.769 3.58905 35.6127 3.15707 36.6176 3.15707C38.6851 3.15707 40.3083 4.85917 40.3083 7.10928C40.3083 9.3594 38.6529 11.0744 36.5725 11.0744C35.6063 11.0744 34.8141 10.694 34.2601 10.0493V14.0788H32.3214V14.0853Z" fill="black"/><path d="M47.0903 7.12873C47.0903 5.83926 46.1563 4.93664 45.0098 4.93664C43.8633 4.93664 42.9293 5.8586 42.9293 7.12873C42.9293 8.38596 43.8633 9.32082 45.0098 9.32082C46.1563 9.32082 47.0903 8.41819 47.0903 7.12873ZM47.1096 10.9584V9.96555C46.5428 10.6554 45.699 11.0809 44.6942 11.0809C42.5944 11.0809 41.0034 9.39819 41.0034 7.12873C41.0034 4.87861 42.6588 3.16362 44.7393 3.16362C45.7183 3.16362 46.5428 3.59559 47.1096 4.26611V3.29901H48.9904V10.9584H47.1096V10.9584Z" fill="black"/><path d="M28.9273 4.04681C28.9273 4.04681 29.4039 3.15707 30.5827 3.15707C31.0851 3.15707 31.4071 3.33115 31.4071 3.33115V5.28469C31.4071 5.28469 30.6986 4.84627 30.048 4.93654C29.3975 5.0268 28.9853 5.61995 28.9853 6.41942V10.9519H27.04V3.29892H28.9208V4.04681H28.9273Z" fill="black"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.9 101.10000000000001" width="2500" height="558"><path d="M79.7 0H57.4c0 18.3-8.4 35-23 46l-8.8 6.6 34.2 46.6h28.1L56.4 56.3C71.3 41.5 79.7 21.5 79.7 0zM0 0h22.8v99.2H0zM94.5 0H116v99.2H94.5zM304.6 28.7c-8.2 0-16 2.5-21.2 9.6v-7.7H263v68.6h20.7v-36c0-10.4 7-15.5 15.4-15.5 9 0 14.2 5.4 14.2 15.4v36.2h20.5V55.6c0-16-12.7-26.9-29.2-26.9zM181 30.6V35c-5.8-4-12.8-6.3-20.4-6.3-20 0-36.2 16.2-36.2 36.2s16.2 36.2 36.2 36.2c7.6 0 14.6-2.3 20.4-6.3v4.4h20.5V30.6zm-18.7 51.9c-10.3 0-18.6-7.9-18.6-17.6s8.3-17.6 18.6-17.6 18.6 7.9 18.6 17.6-8.3 17.6-18.6 17.6zM233.3 39.5v-8.9h-21v68.6h21.1v-32c0-10.8 11.7-16.6 19.8-16.6h.2v-20c-8.3 0-16 3.6-20.1 8.9zM397.6 30.6V35c-5.8-4-12.8-6.3-20.4-6.3-20 0-36.2 16.2-36.2 36.2s16.2 36.2 36.2 36.2c7.6 0 14.6-2.3 20.4-6.3v4.4h20.5V30.6zm-18.7 51.9c-10.3 0-18.6-7.9-18.6-17.6s8.3-17.6 18.6-17.6 18.6 7.9 18.6 17.6c.1 9.7-8.3 17.6-18.6 17.6zM434 32.6c0-1-.7-1.6-1.8-1.6h-1.9v5.2h.9v-1.9h1l.8 1.9h1l-.9-2.1c.6-.3.9-.8.9-1.5zm-1.8.8h-1v-1.6h1c.6 0 .9.3.9.8s-.2.8-.9.8z"/><path d="M431.9 28.8c-2.7 0-4.9 2.2-4.9 4.9.1 2.7 2.2 4.9 4.9 4.9s4.9-2.2 4.9-4.9-2.2-4.9-4.9-4.9zm0 8.9c-2.2 0-3.9-1.8-3.9-4s1.8-4 3.9-4c2.2 0 3.9 1.8 3.9 4s-1.8 4-3.9 4zM440 74.9c-7.1 0-12.9 5.8-12.9 12.9s5.8 12.9 12.9 12.9 12.9-5.8 12.9-12.9c0-7.2-5.8-12.9-12.9-12.9z"/></svg>`;
  //       let payIcons = `<svg class="icon icon-zippay-svg" xmlns="http://www.w3.org/2000/svg" width="57" height="20" viewBox="0 0 57 20"><g fill="none" fill-rule="nonzero"><g fill="#272560"><path d="M27.843 16.338a1.28 1.28 0 0 1-.96-.38 1.306 1.306 0 0 1-.362-.943c-.004-.35.086-.696.26-1.003.153-.275.34-.531.557-.763l5.377-5.873h-4.687c-.454 0-.78-.15-.958-.45-.173-.3-.26-.64-.25-.983a1.498 1.498 0 0 1 .282-.93.991.991 0 0 1 .838-.39h8.282c.35-.015.691.109.945.343.234.226.354.55.354.958.01.318-.06.634-.2.921-.137.25-.307.482-.507.688l-5.6 6.05h5.306c.32-.007.623.133.818.377.208.273.313.607.297.945.015.353-.072.703-.252 1.01-.182.28-.504.424-.956.424l-8.584-.001zM40.852 16.492c-1.474 0-1.78-.73-1.78-1.344V6.202c0-.468.145-.846.434-1.125.29-.278.75-.42 1.372-.42.523 0 .937.115 1.232.343.295.228.459.596.459 1.069V15.1c0 .491-.16.853-.477 1.075-.316.223-.722.316-1.24.316zm0-12.795c-.574 0-1.045-.163-1.401-.483-.356-.32-.542-.762-.542-1.305a1.69 1.69 0 0 1 .54-1.282c.352-.335.825-.505 1.403-.505.477 0 .94.152 1.32.43.413.294.624.752.624 1.36 0 .544-.183.984-.542 1.307-.36.324-.83.481-1.402.481v-.003zM46.411 19.92c-1.378 0-1.67-.742-1.67-1.366V5.899c-.011-.396.146-.78.437-1.06.288-.279.75-.42 1.371-.42.387-.005.768.081 1.113.249.367.181.557.537.557 1.048a4.145 4.145 0 0 1 1.019-.854 4.342 4.342 0 0 1 2.3-.619 5.15 5.15 0 0 1 2.253.471 4.567 4.567 0 0 1 1.636 1.308c.45.591.779 1.26.968 1.972.217.803.323 1.63.316 2.46a8.26 8.26 0 0 1-.363 2.5 5.81 5.81 0 0 1-1.062 1.983 4.876 4.876 0 0 1-1.72 1.306 5.514 5.514 0 0 1-2.32.47 4.91 4.91 0 0 1-1.581-.215 4.427 4.427 0 0 1-1.036-.496 2.842 2.842 0 0 1-.48-.394v2.881c0 .501-.14.871-.42 1.1-.28.227-.709.332-1.318.332zm4.237-12.81a2.275 2.275 0 0 0-1.09.248 2.349 2.349 0 0 0-.79.702c-.23.327-.398.692-.496 1.076a5.291 5.291 0 0 0-.168 1.364c0 1.047.223 1.887.668 2.497.445.61 1.05.894 1.88.894.83 0 1.435-.305 1.855-.934.42-.629.643-1.467.643-2.457a5.293 5.293 0 0 0-.174-1.36 3.43 3.43 0 0 0-.485-1.075 2.244 2.244 0 0 0-.779-.7 2.223 2.223 0 0 0-1.064-.255z"></path></g><g><path fill="#F15B41" d="M20.313 7.45l-4.589 3.987H4.36a4.43 4.43 0 0 0-2.878 1.049l5.731-4.982.088-.075 7.18-6.246a4.475 4.475 0 0 1 4.265-.874c1.481.466 2.593 1.66 2.916 3.13.323 1.473-.192 2.999-1.35 4.005v.005z"></path><ellipse cx="4.36" cy="4.319" fill="#F99D1D" rx="4.36" ry="4.212"></ellipse><path fill="#272560" d="M4.36 11.437a4.43 4.43 0 0 0-2.878 1.049l-.037.032c-1.79 1.556-1.936 4.218-.326 5.948 1.61 1.729 4.366 1.87 6.156.315l8.45-7.343-11.365-.001z"></path><path fill="#00B6BD" d="M15.718 11.44l-8.45 7.343a4.43 4.43 0 0 1-2.916 1.075H17.39c2.515-.039 4.29-1.866 4.29-4.211s-1.91-4.175-4.29-4.212l-1.672.005z"></path></g></g></svg><svg width="74" height="15" viewBox="0 0 74 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M72.8744 2.87339L70.6458 1.59682L68.385 0.300907C66.8906 -0.556587 65.0227 0.520115 65.0227 2.248V2.53813C65.0227 2.69931 65.1065 2.8476 65.2482 2.92497L66.2981 3.52457C66.5879 3.6922 66.9486 3.47944 66.9486 3.14418V2.45431C66.9486 2.1126 67.3158 1.89984 67.6121 2.06747L69.6732 3.25378L71.7279 4.43364C72.0242 4.60127 72.0242 5.03324 71.7279 5.20087L69.6732 6.38073L67.6121 7.56704C67.3158 7.73467 66.9486 7.52191 66.9486 7.1802V6.83849C66.9486 5.11061 65.0807 4.02746 63.5864 4.8914L61.3255 6.18731L59.0969 7.46388C57.5961 8.32782 57.5961 10.5006 59.0969 11.3645L61.3255 12.6411L63.5864 13.937C65.0807 14.7945 66.9486 13.7178 66.9486 11.9899V11.6998C66.9486 11.5386 66.8649 11.3903 66.7232 11.3129L65.6733 10.7133C65.3834 10.5457 65.0227 10.7585 65.0227 11.0937V11.7836C65.0227 12.1253 64.6556 12.3381 64.3593 12.1704L62.2981 10.9841L60.2434 9.80426C59.9471 9.63663 59.9471 9.20466 60.2434 9.03703L62.2981 7.85717L64.3593 6.67086C64.6556 6.50323 65.0227 6.71599 65.0227 7.0577V7.39941C65.0227 9.12729 66.8906 10.2104 68.385 9.3465L70.6458 8.05059L72.8744 6.77402C74.3752 5.90363 74.3752 3.73733 72.8744 2.87339Z" fill="black"/><path d="M58.2531 3.29906L53.0358 14.0854H50.8716L52.8233 10.0559L49.7509 3.29906H51.973L53.944 7.82508L56.0953 3.29906H58.2531Z" fill="black"/><path d="M6.08684 7.12873C6.08684 5.83926 5.15288 4.93664 4.00636 4.93664C2.85985 4.93664 1.92589 5.8586 1.92589 7.12873C1.92589 8.38596 2.85985 9.32082 4.00636 9.32082C5.15288 9.32082 6.08684 8.41819 6.08684 7.12873ZM6.10616 10.9584V9.96555C5.53934 10.6554 4.69556 11.0809 3.69075 11.0809C1.59095 11.0809 0 9.39819 0 7.12873C0 4.87861 1.65536 3.16362 3.73584 3.16362C4.71488 3.16362 5.53934 3.59559 6.10616 4.26611V3.29901H7.98696V10.9584H6.10616V10.9584Z" fill="black"/><path d="M17.1339 9.25639C16.4769 9.25639 16.2901 9.01139 16.2901 8.36666V4.96892H17.5011V3.29906H16.2901V1.42934H14.3643V3.29906H11.878V2.53828C11.878 1.89355 12.1228 1.64855 12.7991 1.64855H13.2242V0.165665H12.2967C10.7057 0.165665 9.9521 0.687897 9.9521 2.28038V3.30551H8.88287V4.96892H9.9521V10.9585H11.878V4.96892H14.3643V8.72126C14.3643 10.2815 14.9633 10.9585 16.522 10.9585H17.514V9.25639H17.1339Z" fill="black"/><path d="M24.0509 6.43876C23.9157 5.44587 23.1041 4.84627 22.1508 4.84627C21.2039 4.84627 20.4181 5.42653 20.2249 6.43876H24.0509ZM20.2056 7.63152C20.3408 8.76625 21.1524 9.41098 22.183 9.41098C22.9946 9.41098 23.6194 9.03059 23.9865 8.41809H25.9639C25.5066 10.0428 24.0509 11.0808 22.1379 11.0808C19.8256 11.0808 18.2024 9.45611 18.2024 7.14152C18.2024 4.82693 19.9157 3.15707 22.183 3.15707C24.4631 3.15707 26.1185 4.83983 26.1185 7.14152C26.1185 7.30915 26.1056 7.47678 26.0734 7.63152H20.2056V7.63152Z" fill="black"/><path d="M38.3824 7.12863C38.3824 5.89074 37.4485 4.93654 36.3019 4.93654C35.1554 4.93654 34.2215 5.8585 34.2215 7.12863C34.2215 8.38585 35.1554 9.32072 36.3019 9.32072C37.4485 9.32072 38.3824 8.37296 38.3824 7.12863ZM32.3214 14.0853V3.29892H34.2021V4.2918C34.769 3.58905 35.6127 3.15707 36.6176 3.15707C38.6851 3.15707 40.3083 4.85917 40.3083 7.10928C40.3083 9.3594 38.6529 11.0744 36.5725 11.0744C35.6063 11.0744 34.8141 10.694 34.2601 10.0493V14.0788H32.3214V14.0853Z" fill="black"/><path d="M47.0903 7.12873C47.0903 5.83926 46.1563 4.93664 45.0098 4.93664C43.8633 4.93664 42.9293 5.8586 42.9293 7.12873C42.9293 8.38596 43.8633 9.32082 45.0098 9.32082C46.1563 9.32082 47.0903 8.41819 47.0903 7.12873ZM47.1096 10.9584V9.96555C46.5428 10.6554 45.699 11.0809 44.6942 11.0809C42.5944 11.0809 41.0034 9.39819 41.0034 7.12873C41.0034 4.87861 42.6588 3.16362 44.7393 3.16362C45.7183 3.16362 46.5428 3.59559 47.1096 4.26611V3.29901H48.9904V10.9584H47.1096V10.9584Z" fill="black"/><path d="M28.9273 4.04681C28.9273 4.04681 29.4039 3.15707 30.5827 3.15707C31.0851 3.15707 31.4071 3.33115 31.4071 3.33115V5.28469C31.4071 5.28469 30.6986 4.84627 30.048 4.93654C29.3975 5.0268 28.9853 5.61995 28.9853 6.41942V10.9519H27.04V3.29892H28.9208V4.04681H28.9273Z" fill="black"/></svg>`;
  //       document.querySelector('.afterpay-text1').innerHTML = 'or 4 instalments of ';
  //       document.querySelector('.afterpay-text2').innerHTML = ' with ' ;
  //       document.querySelector('.afterpay-logo').style.display = "none";
  //       document.querySelector('.afterpay-link').style.display = "none";
  //       document.querySelector('.afterpay-text3').innerHTML = `${payIcons}`;
  //     }
  //   },100);
  // }
  
  // mobile utility bar slider
  const utilitySlider = document.querySelector('#store-messages');
  if (window.innerWidth <= 767) {
    new Swiper(utilitySlider, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      }
    });
  }
  
  var firstSection = document.body.querySelector('#page-content .shopify-section:first-child');
  if(firstSection) {
    var firstBgSet = firstSection.querySelector('[data-bgset]');
    
    if (firstBgSet) {
      var bgSets = firstBgSet.dataset.bgset.split(',');
      if(bgSets) {
        for (var i = 0; i < bgSets.length; i++) {
          var widthMatch = bgSets[i].match(/ [0-9]+w/g);
          var heightMatch = bgSets[i].match(/ [0-9]+h/g);
          
          if(widthMatch && heightMatch) {
            var width = parseInt(widthMatch[0].replace('w', '').trim());
            var height = parseInt(heightMatch[0].replace('h', '').trim());
            
            if (width >= window.innerWidth && height >= window.innerHeight) {
              firstBgSet.style.backgroundImage = "url('" + bgSets[i].trim().split(' ')[0] + "')";
              firstBgSet.classList.remove('fade-in');
              break;
            }
          }
        }
      } 
    } else if (firstSection.querySelector('[data-src]')) {
      var firstDataSrc = firstSection.querySelector('[data-src]');
      var widths = JSON.parse(firstDataSrc.dataset.widths);
      for (var i = 0; i < widths.length; i++) {
        var width = parseInt(widths[i]);
        if (width >= window.innerWidth) {
          firstDataSrc.setAttribute('src', firstDataSrc.dataset.src.replace('{width}', width));
          firstDataSrc.classList.remove('fade-in');
          break;
        }
      }
    }
  }
  
  
  //Calculate the viewport height
  theme.calc100vh = function() {
    var nav = document.getElementById('site-control');
    document.documentElement.style.setProperty('--viewport-height-first-section',
    `${(nav.dataset.opacity === 'opaque') ? window.innerHeight - nav.clientHeight : window.innerHeight}px`);
    document.documentElement.style.setProperty('--viewport-height',
    (nav.dataset.opacity.indexOf('opaque') > -1 && nav.dataset.positioning === "sticky") ? `calc(100vh - ${nav.clientHeight}px)` : "100vh");
  }
  theme.calc100vh();
  
  // $(document).on('click','#filterTrigger',function(e){
  //   $(this).text().includes('Show Filters') ? $(this).addClass('active').find('span').text('Hide Filters') : $(this).removeClass('active').find('span').text('Show Filters');
  //   if (window.innerWidth <= 767 ) {
  //     e.stopPropagation();
  //     $('.theme-filter-container .cc-product-filter').toggleClass('-in');
  //     $('.theme-filter-container .cc-product-filter').css("display","block");
  //     $('#shopify-section-header').hide();
  //   }else{
  //     $('.theme-filter-container .cc-product-filter').animate({width: 'toggle'});
  //     $('#shopify-section-header').show();
  //   }
  // });

  $(document).ready(function() {
  // Define collections where filter should be open by default
  const autoOpenCollections = [
    'sale-items'
    // Add more collection handles as needed
  ];

  // Get current collection handle from the URL or body class
  const currentCollection = window.location.pathname.split('/').pop();
  const isAutoOpenCollection = autoOpenCollections.includes(currentCollection);

  // Modify your click handler
  $(document).on('click', '#filterTrigger', function(e) {
    $(this).text().includes('Show Filters') ? 
      $(this).addClass('active').find('span').text('Hide Filters') : 
      $(this).removeClass('active').find('span').text('Show Filters');
    
    if (window.innerWidth <= 767) {
      e.stopPropagation();
      $('.theme-filter-container .cc-product-filter').toggleClass('-in');
      $('.theme-filter-container .cc-product-filter').css("display", "block");
      $('#shopify-section-header').hide();
    } else {
      $('.theme-filter-container .cc-product-filter').animate({width: 'toggle'});
      $('#shopify-section-header').show();
    }
  });

  // Auto-open for specific collections
  if (isAutoOpenCollection) {
    $('#filterTrigger').addClass('active').find('span').text('Hide Filters');
    
    if (window.innerWidth <= 767) {
      $('.theme-filter-container .cc-product-filter').addClass('-in');
      $('.theme-filter-container .cc-product-filter').css("display", "block");
      $('#shopify-section-header').hide();
    } else {
      $('.theme-filter-container .cc-product-filter').show();
    }
  }
});
  // ----------------------------------------------------------------------------
  
  $(document).on('click','#FacetsForm .closePopup',function(){
    $('#filterTrigger').removeClass('active');
    $('.theme-filter-container .cc-product-filter').removeClass('-in');
    $('#shopify-section-header').show();
    $('#filterTrigger span').text('Show filters');
  });

  if (window.innerWidth <= 767) {
    $('.section-footer__title').click(function(){
      $('.section-footer__menu-block').removeClass('active');
      $(this).toggleClass('active');
      $(this).siblings('.section-footer__menu-block__menu').slideToggle('300');                                                                                  
    });
    $(document).on('click', function(e) {
      let pFilter = $('.cc-product-filter');
      if (e.target != pFilter && pFilter.has(e.target).length === 0) {
        $('#FacetsForm .closePopup').trigger('click');
      }
    })
   }  

 // collection description hide on mobile 
  if (window.innerWidth <= 767 ) {
    $('.collection-header .faq-ans1').hide();
  }


  $('.colletion-faqs-section .faq-que').click(function(){
    $(this).toggleClass('active');
    $(this).siblings('.faq-ans').slideToggle('300');
  });
 
  $(document).on('change', '.cust-filter-header .plp-accordion-item__panel-grid-Sortby input',function(){
    var currVal = $(this).val();
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set("sort_by",currVal);
    window.location.search =  searchParams.toString();
  })
  
  if(window.innerWidth > 767){
    $('.theme-filter-container .cc-product-filter').css('display','none');
  }
  if(window.innerWidth <= 767){
	$('.cc-product-filter').show();
  }
  // toxic free home {page} tabs
  $(document).on('click','#expandAccordion',function(){
    $(this).siblings('.list-wrapper').css('max-height','100%');
    $(this).addClass('active').text('- See Less');
  });
  $(document).on('click','#expandAccordion.active',function(){
    $(this).siblings('.list-wrapper').removeAttr('style');
    $(this).removeClass('active').text('+ Expand');
  });
  if($(window).width() < 767){
    $('.toxic-free-price-wrapper').slick({
      dots:true,
      arrows:true,
      adaptiveHeight: true,
      prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
    }); 
  }
  $(document).on('change','.plan-selection-wrapper select[name="id"]',function(){
    var price = $(this).find(':selected').attr('data-price'),
    comPrice = $(this).find(':selected').attr('data-compare-price');
    $('#custMobPrice').text(price);
    $('#custMobComPrice').text(comPrice);
  });
  $(".toxic-free-banner-get-started").on('click', function() {
    $('html, body').animate({
      scrollTop: $( '#toxic-free-banner-get-started').offset().top - 150
    }, 'slow');
  });
  $('.plan-selection').change(function() {
    var planselection = $(this).val();
    $("#hiddenmonthyearlydata").val(planselection);
  });
  $(document).on('click','.plan-selection-swatch .swetch-wrapper input',function(){
    var price = $(this).attr('data-price'),
    comPrice = $(this).attr('data-compare-price');
    $('#custMobPrice').text(price);
    $('#custMobComPrice').text(comPrice);
    var dataurlswatches = $(this).attr('data-url');
    $('.mobile-swatches-dataurl').attr('href',dataurlswatches);
  });
  
  // icon with text slider on mobile
  if (window.innerWidth <= 767) {
    new Swiper(".icon-with-text-slider", {
      slidesPerView: 2,
      spaceBetween: 20,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      }
    });
    new Swiper(".text-column-img-slider", {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 4,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    });
    if (document.querySelector('.text-column-img-slider .rimage-outer-wrapper')) {
      let textColTopPosition = document.querySelectorAll('.text-column-img-slider .rimage-outer-wrapper')[1].clientHeight;
      document.querySelector('.swiper-arrow-wrapper').style.top = `${textColTopPosition}px`;
    }
  }

  // logo section slider
  new Swiper(".featured-logo-wrapper.swiper", {
    slidesPerView: 5,
    loop: true,
    spaceBetween: 0,
    centeredSlides: true,
      breakpoints: {
        992: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
        1199: {
          slidesPerView: 5,
        }
      }
  });
  new Swiper(".custom-shop-by-brand-homesection .featured-logo-wrapper.swiper", {
    autoplay: {
        delay: 3000,
     },
     slidesPerView: 6,
    loop: true,
    spaceBetween: 0,
    centeredSlides: true,
      breakpoints: {
        992: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 4,
        },
        1199: {
          slidesPerView: 6,
        }
      }
  });

  // on keypress submit form
  window.cacheTimeout = null;
  $(document).on('keyup','#FacetsForm .cc-price-range__input-row input', function(event){
    clearTimeout(window.timeout);
    window.timeout = setTimeout(function(){
    $('#FacetsForm').submit(); 
    }, 1000); 
  });


	
});

function lightboxmessage(){ 
	jQuery('#terms_of_services .popup-mask').fadeIn();
    jQuery('#terms_of_services .popup-content').fadeIn();
    jQuery('#terms_of_services .close-element').click(function() {
    jQuery('#terms_of_services .popup-mask').fadeOut();
    jQuery('#terms_of_services .popup-content').fadeOut();
    });
}

// script.js
const footer = document.getElementById('shopify-section-footer');
const section = document.querySelector('.pdp-sticky-cart');
const formButton = document.querySelector('.product-detail__form__action');
const pageContent = document.querySelector('#page-content');

// Function to add the class to the section when scrolling reaches the footer
function addClassOnScroll() {
    const footerPosition = footer.getBoundingClientRect().top;
    const sectionPosition = section.getBoundingClientRect().top;
    const formButtonPosition = formButton.getBoundingClientRect().bottom + 300 ;

    if (sectionPosition <= footerPosition && sectionPosition >= formButtonPosition ) {
        pageContent.classList.add("active");
        section.classList.add('active');
    } else {
        pageContent.classList.remove("active");
        section.classList.remove('active');
    }
}

// Attach the scroll event listener to the window
window.addEventListener('scroll', addClassOnScroll);


let discount = document.querySelector('.component-apply-discount');
let discountUrlEl = document.querySelector('.component-apply-discount .discount-url');
let pdpTitleEl = document.querySelector('.product-area__details__title');

if (discount && discountUrlEl && pdpTitleEl) {
  let discount_url = discountUrlEl.innerHTML;
  let pdp_name = pdpTitleEl.innerHTML;

  discount.addEventListener('click',function(){
    window.history.pushState("", "", discount_url);
    discount.classList.add('applied');

    $.ajax({
    url: window.location.href,
    type: "GET",
    success: function(data) {
      // Reload the page with the updated content
      location.reload();
    },
    error: function(error) {
      // Handle any errors that occur during the AJAX request
      console.error("Error during AJAX request:", error);
    }
    });

    function setSessionCookie(name, value) {
    document.cookie = name + "=" + value + "; path=/";
    }
    // To set a session cookie
    setSessionCookie( pdp_name , pdp_name);

  });

  function getSessionCookieValue(name) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.indexOf(name + "=") === 0) {
        return cookie.substring(name.length + 1, cookie.length);
      }
    }
      return null; // Return null if the session cookie is not found
    }

    // To retrieve the value of a session cookie
    const mySessionCookieValue = getSessionCookieValue(pdp_name);

    if (mySessionCookieValue == pdp_name ) {
      discount.classList.add('applied');
    }
}
